//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapStores } from 'pinia'
import { useSupplierStore } from '@/store/supplier'
import { useUserStore } from '@/store/user'
import { AllowedScopes } from '@/model/xeroScopes'
import { useXeroStore } from '~/store/xero'
import CreateBankAccountCard from '~/components/modals/CreateBankAccountCard.vue'
import MissingXeroScopeCard from '~/components/modals/MissingXeroScopeCard.vue'

export default {
    components: { CreateBankAccountCard, MissingXeroScopeCard },
    data() {
        return {
            clipped: false,
            drawer: false,
            fixed: false,
            items: [
                {
                    icon: 'mdi-apps',
                    title: 'Welcome',
                    xeroAccessRequired: false,
                    to: '/',
                },
                {
                    icon: 'mdi-cash-multiple',
                    title: 'Payment Services',
                    xeroAccessRequired: true,
                    to: '/payment-services',
                },
                {
                    icon: 'mdi-account-group',
                    title: 'Suppliers',
                    xeroAccessRequired: true,
                    to: '/suppliers',
                },
                {
                    icon: 'mdi-file-document-multiple-outline',
                    title: 'Statements',
                    xeroAccessRequired: true,
                    to: '/statements',
                },
            ],
            miniVariant: false,
            title: 'Netcash Xero',
            currentUser: {
                name: '',
            },
            xeroInfo: {
                isConnected: false,
                currentTenantId: null,
                tenants: [],
            },
            snackbar: {
                color: 'success',
                visible: false,
                messages: [],
                timeout: -1,
            },
            createBankAccountDialog: false,
            missingXeroScopeDialog: false,
        }
    },
    async fetch() {
        if (this.$auth.loggedIn) {
            this.currentUser = await this.userStore.fetchUser()
            this.xeroInfo = await this.userStore.fetchXeroInfo()
            const errorContent = []

            if (this.xeroInfo.isConnected) {
                if (this.xeroInfo.missingScopes.length > 0) {
                    this.missingXeroScopeDialog = true
                }
                if (!this.currentUser.hasMappedAccounts) {
                    errorContent.push(
                        'It seems you have not mapped your Xero accounts yet, please ensure to go to the Statements page to update.',
                    )
                }
                if (this.userStore.hasScope(AllowedScopes.BANKFEEDS)) {
                    if (this.feedConnection == null) {
                        await this.xeroStore.fetchFeedConnection()
                    }

                    if (this.feedConnection.id == null) {
                        this.createBankAccountDialog = true
                    }
                }

                if (!this.currentUser.hasServiceKeys) {
                    errorContent.push('It seems you have no service keys attached to your Netcash Account.')
                }
            }

            if (errorContent.length > 0) {
                this.showSnackbar(errorContent, true)
            }
        }
    },
    computed: {
        xeroTenantName() {
            const tenant = this.xeroInfo.tenants.find(x => x.id === this.xeroInfo.currentTenantId)
            if (tenant) {
                return tenant.name
            }
            return undefined
        },
        ...mapStores(useXeroStore, useSupplierStore, useUserStore),
        ...mapState(useXeroStore, ['feedConnection']),
        menuItems() {
            return !this.xeroInfo.isConnected || !this.currentUser.hasServiceKeys
                ? this.items.filter(x => !x.xeroAccessRequired)
                : this.items
        },
    },
    methods: {
        async logout() {
            await this.$auth.logout()
            window.location.replace('/')
        },
        connectToXero() {
            window.location = '/xero/connect'
        },
        disconnectFromXero() {
            window.location = `/xero/disconnect?tenantId=${this.xeroInfo.currentTenantId}`
        },
        async updateXeroTenant(tenantId) {
            if (tenantId === this.xeroInfo.currentTenantId) {
                return
            }
            try {
                await this.$axios.$put('/api/xero/current-tenant', {
                    tenantId,
                })
                this.showSnackbar(['Current Xero Organisation updated'])
                this.$nuxt.$loading.start()
                this.xeroInfo = await this.userStore.fetchXeroInfo(true)
                await this.supplierStore.setSuppliers()
                await this.xeroStore.fetchAccounts()
            } catch ({ response }) {
                this.showSnackbar(response.data.message, true)
            }
        },
        showSnackbar(messages, isError) {
            this.snackbar.messages = messages
            this.snackbar.color = isError ? 'error' : 'success'
            this.snackbar.visible = true
        },
    },
}

/*
 The javascript hereafter removes the trailing hash from the URL after canceling the xero account linking caused by Passport-Facebook.
 Link to the discussion:
 https://stackoverflow.com/questions/23875737/how-can-i-stop-the-momentary-redirect-with-the-on-the-url-when-using-facebo
*/

if (window.location.hash === '#_=_') {
    window.location.hash = ''
}
